import { back } from '../../../helpers/history';
import Logger from '../../../services/Logger';

const destroyWebsiteSettings = () => {
  Logger.log('User', 'WebSiteSettingsClose');
  back();
};

export default destroyWebsiteSettings;
